import React from "react";
import PropTypes from "prop-types";
import { Card, CardBody, Row, Col } from "reactstrap";

export function SLImageSelectable({
  imageSource,
  image,
  selected,
  title,
  onChange = (e) => {},
  name,
  value,
  disabled = false
}) {
  return ( <Card
        className={
          "mb-0 pb-0 cursor-pointer image-selectable-card  justify-content-center" +
          (selected === true
            ? " image-selectable-card-selected"
            : " image-selectable-card-non-selected")
        }
        onClick={ disabled === false ? () => onChange({ target: { name, value } }) : e => e.preventDefault()}
      >
        <CardBody className={"p-3 mb-0 w-100 h-100  justify-content-center d-flex"}>
          <div className="m-0 p-0 text-center w-100">
            {imageSource && (
              <img
                src={imageSource}
                alt={title}
                className={
                  "image-selectable-img" +
                  (selected === true
                    ? " image-selectable-img-selected"
                    : " image-selectable-img-non-selected")
                }
              />
            )}
            {image && <span>{ image }</span>}
          </div>
           
          <p className="m-0 p-0 text-center w-100">
            <label
              className={
                "image-selectable-title" +
                (selected === true
                  ? " image-selectable-title-selected"
                  : " image-selectable-title-non-selected")
              }
            >
              {title}
            </label>
          </p>
        </CardBody>
      </Card>    
  );
}
SLImageSelectable.propTypes = {
  selected: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  onClick: PropTypes.func,
};



// WEBPACK FOOTER //
// ./src/components/editors/SLImageSelectable.jsx